<div>
  <mat-card>
    <div class="mt-4 w-full flex justify-content-center align-content-center">
      <img class="w-3" src="../../../../../assets/alert.png" alt="" />
    </div>
    <mat-card-title class="text-center" mat-dialog-title
      >¡Precaución!</mat-card-title
    >

    <mat-card-content>
      <mat-dialog-content>
        <p class="text-center">
          {{ name }}, código {{ code }} se eliminará irreversiblemente.
        </p>
        <p class="text-center">¿desea continuar?</p>
      </mat-dialog-content>
      <mat-dialog-actions class="w-full gap-2 flex justify-content-evenly mb-3">
        <shared-button
          [icon]="'delete_forever'"
          [typeBtn]="'submit'"
          [color]="'warn'"
          (click)="accept()"
          >Continuar</shared-button
        >

        <shared-button
          mat-dialog-close
          [icon]="'cancel'"
          [typeBtn]="'button'"
          [color]="'accent'"
          >Cancelar</shared-button
        >
      </mat-dialog-actions>
    </mat-card-content>
  </mat-card>
</div>
